var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.formatted}},[_vm._v(_vm._s(_vm.displayDate))])
}
var staticRenderFns = []

export { render, staticRenderFns }